import styled from "styled-components";

import LeftArrow  from '../../../assets/icons/table-left-arrow.svg';
import RightArrow  from '../../../assets/icons/table-right-arrow.svg';

const TableDiv = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 35px;
`;

const TableWrapper = styled.div`
  width: 100%;
  overflow-x: auto;
  scroll-behavior: smooth;
  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

const TableContainer = styled.table`
  width: 855px;
  margin: 0 auto;
  border-spacing: 0;
  display: flex;
  flex-direction: column;

  tbody {
    tr {
      padding: 11px 0;
      border-bottom: 1px solid #f2f2f2;
    }
  }

  tr {
    width: 100%;
    display: flex;

    th,
    td {
      width: 25%;
      text-align: start;

      &:nth-child(2) {
        width: 34%;
      }
    }

    th {
      padding-bottom: 28px;
      border-bottom: 1px solid #f2f2f2;
      font-size: 16px;
      line-height: 16px;
      font-family: "Eina01-Medium";
      font-weight: 400;
      color: #d4fc00;
      text-transform: uppercase;
    }

    td {
      font-weight: 400;
      font-size: 16px;
      line-height: 18px;
      color: #ffffff;
      font-family: "Eina01-Medium";
    }
  }
`;

const ScrollButton = styled.button`
  width: 9px;
  height: 17px;
  position: absolute;
  bottom: 0;
  border: none;
  background-color: transparent;
  z-index: 8;
  cursor: pointer;

  &.left {
    left: 0;

    &:before {
      content: url(${LeftArrow});
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 9px;
      height: 17px;
    }
  }

  &.right {
    right: 0;

    &:before {
      content: url(${RightArrow});
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 9px;
      height: 17px;
    }
  }
`;

export { TableDiv, TableWrapper, TableContainer, ScrollButton };